import React from 'react';

import { useAuthStore } from '../context/stores';
import LoginPage from '../components/LoginPage';
import YearbookDashboard from '../layout/YearbookDashboard';
import NoProjectPage from '../components/NoProjectPage';

/**
 * Owns the authenticated vs logged-out boundary.
 * Waits for Firebase + backend auth before opening the dashboard.
 */
export default function AuthGate() {
  const {
    isAuthenticated,
    authReady,
    logout,
    parentAccess,
  } = useAuthStore();

  if (!authReady) {
    return null; // Replace with LoadingScreen if you have one.
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (
    parentAccess?.status === 'no_projects' ||
    parentAccess?.code === 'NO_PARENT_PROJECTS'
  ) {
    return <NoProjectPage logout={logout} parentAccess={parentAccess} />;
  }

  return <YearbookDashboard logout={logout} />;
}